import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";
import TextareaAutosize from "react-textarea-autosize";

interface RequestIntegrationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  value: string;
  onValueChange: (value: string) => void;
  loading: boolean;
  success: boolean;
  onSubmit: () => void;
}

export const RequestIntegrationDialog = ({
  open,
  onOpenChange,
  value,
  onValueChange,
  loading,
  success,
  onSubmit,
}: RequestIntegrationDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("team.integrations.request.title")}</DialogTitle>
          <DialogDescription>
            {t("team.integrations.request.description")}
          </DialogDescription>
        </DialogHeader>
        {success ? (
          <div className="py-4 text-green-700">
            {t("team.integrations.request.success")}
          </div>
        ) : (
          <div className="grid gap-4 py-4">
            <div className="grid gap-2">
              <Label htmlFor="integration-request">
                {t("team.integrations.request.label")}
              </Label>
              <TextareaAutosize
                id="integration-request"
                value={value}
                onChange={(e) => onValueChange(e.target.value)}
                placeholder={t("team.integrations.request.placeholder")}
                minRows={4}
                className="px-3 py-2 w-full rounded-md border focus:outline-hidden focus:ring-3"
              />
            </div>
          </div>
        )}
        <DialogFooter>
          {success ? (
            <Button
              type="button"
              variant="default"
              onClick={() => onOpenChange(false)}
            >
              {t("team.integrations.ok")}
            </Button>
          ) : (
            <>
              <Button
                type="button"
                variant="outline"
                onClick={() => onOpenChange(false)}
                disabled={loading}
              >
                {t("team.integrations.request.cancel")}
              </Button>
              <Button
                type="button"
                onClick={onSubmit}
                disabled={!value.trim() || loading}
              >
                {loading ? (
                  <span className="flex justify-center items-center">
                    <span className="mr-2 loader" />
                    {t("team.integrations.request.sending")}
                  </span>
                ) : (
                  t("team.integrations.request.button")
                )}
              </Button>
            </>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
